import { render, staticRenderFns } from "./ModalRicePoint.vue?vue&type=template&id=f71260a2&scoped=true"
import script from "./ModalRicePoint.vue?vue&type=script&lang=js"
export * from "./ModalRicePoint.vue?vue&type=script&lang=js"
import style0 from "./ModalRicePoint.vue?vue&type=style&index=0&id=f71260a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71260a2",
  null
  
)

export default component.exports